export interface IPackaging {
  [key: string]: string | boolean | number | null | IPackagingParts[]
  packagingId: string
  packagingName: string
  active: boolean
  stock: number | null
  capacity: number | null
  unit: string
  weight: number | null
  department: string | null
  pictureUrl: string | null
  packagingParts: IPackagingParts[]
}

export class Packaging {
  [key: string]: string | boolean | number | null | IPackagingParts[]
  packagingId: string
  packagingName: string
  active: boolean
  stock: number | null
  capacity: number | null
  unit: string
  weight: number | null
  department: string | null
  pictureUrl: string | null
  packagingParts: IPackagingParts[]

  constructor({
    packagingId,
    packagingName,
    active,
    stock,
    capacity,
    unit,
    weight,
    department,
    pictureUrl,
    packagingParts,
  }: Partial<IPackaging> = {}) {
    this.packagingId = packagingId || ''
    this.packagingName = packagingName || ''
    this.active = active || false
    this.stock = stock || null
    this.capacity = capacity || null
    this.unit = unit || ''
    this.weight = weight || null
    this.department = department || null
    this.pictureUrl = pictureUrl || null
    this.packagingParts = packagingParts || []
    if (arguments[0]?.packagingPartId) {
      this.packagingParts = [new PackagingParts(arguments[0])]
    }
  }
}

export interface IPackagingParts {
  packagingPartId: string
  partName: string
  stock: number | null
  isNew: boolean
  isFromServer: boolean
  oldPackagingPartId?: string
}

export class PackagingParts {
  packagingPartId: string
  partName: string
  stock: number | null
  isNew: boolean
  isFromServer: boolean
  oldPackagingPartId?: string

  constructor({
    packagingPartId,
    partName,
    stock,
    isNew,
    isFromServer,
    oldPackagingPartId,
  }: Partial<IPackagingParts> = {}) {
    this.packagingPartId = packagingPartId || ''
    this.partName = partName || ''
    this.stock = stock ?? null
    this.isNew = isNew ?? false
    this.isFromServer = isFromServer ?? true
    this.oldPackagingPartId = oldPackagingPartId
  }
}

export interface IPackagingOrder extends IPackagingParts {
  discountType: string
  unitPrice: number | null
  qty: number | null
  discount: number | null
  weight: number | null
  displayDiscount: number | null
  rank: number | null
}

export class PackagingOrder extends PackagingParts {
  discountType: string
  unitPrice: number | null
  qty: number | null
  discount: number | null
  weight: number | null
  displayDiscount: number | null
  rank: number | null

  constructor({
    packagingPartId,
    partName,
    stock,
    isNew,
    isFromServer,
    oldPackagingPartId,
    discountType,
    discount,
    unitPrice,
    qty,
    weight,
    displayDiscount,
    rank,
  }: Partial<IPackagingOrder> = {}) {
    super({
      packagingPartId,
      partName,
      stock,
      isNew,
      isFromServer,
      oldPackagingPartId,
    })
    this.discountType = discountType || ''
    this.unitPrice = unitPrice || null
    this.qty = qty || null
    this.discount = discount || null
    this.weight = weight || null
    this.displayDiscount = displayDiscount || null
    this.rank = rank || null
  }
}
